// mobile-status.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MobileStatusService {
  private _isMobileSubject = new BehaviorSubject<boolean>(false);
  public isMobile$: Observable<boolean> = this._isMobileSubject.asObservable();

  setMobileStatus(isMobile: boolean) {
    this._isMobileSubject.next(isMobile);
  }
}
